import React from 'react';
import {loadCanvasFonts} from '@packages/systems/core/utils/FontUtils';
import {Font} from '@packages/systems/core/constants/Fonts';

type Props = {
  fonts: Font[];
};

export default class GoogleFontsSheet extends React.Component<Props> {
  declare link: HTMLLinkElement | null;
  componentDidMount() {
    if (!this.link) {
      return;
    }
    const siteDocument = this.link.ownerDocument;
    loadCanvasFonts(siteDocument, this.props.fonts);
  }

  componentDidUpdate() {
    if (!this.link) {
      return;
    }
    const siteDocument = this.link.ownerDocument;
    loadCanvasFonts(siteDocument, this.props.fonts);
  }

  shouldComponentUpdate(nextProps: Props) {
    return this.props.fonts !== nextProps.fonts;
  }

  setRef = (element: HTMLLinkElement | null) => {
    this.link = element;
  };

  render() {
    return <link rel="stylesheet" type="text/css" ref={this.setRef} />;
  }
}
